import { ACCOUNT_TYPE } from '@/shared/constants/account-type.constant';
import { SCOPED_ROLE } from '@/shared/constants/scoped-role.constant';

export const ACCOUNT_TYPE_OPTIONS = [
	{ value: ACCOUNT_TYPE.PLATFORM_ADMIN, label: 'Platform Admin' },
	{ value: ACCOUNT_TYPE.B2B, label: 'B2B' },
	{ value: ACCOUNT_TYPE.B2C, label: 'B2C' },
	{ value: ACCOUNT_TYPE.OPERATIONAL, label: 'Operational' },
];

export const B2B_SCOPED_ROLE_OPTIONS = [
	{ value: SCOPED_ROLE.ADMIN, label: 'Admin' },
	{ value: SCOPED_ROLE.EMPLOYEE, label: 'Employee' },
	{ value: SCOPED_ROLE.OTHER, label: 'Other' },
];

export const B2C_SCOPED_ROLE_OPTIONS = [
	{ value: SCOPED_ROLE.OWNER, label: 'Owner' },
	{ value: SCOPED_ROLE.CAPTAIN, label: 'Captain' },
	{ value: SCOPED_ROLE.CREW, label: 'Crew' },
	{ value: SCOPED_ROLE.GUEST, label: 'Guest' },
	{ value: SCOPED_ROLE.OTHER, label: 'Other' },
];
